import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { Chart, ChartConfiguration, ChartData } from 'chart.js';
import { ConfigParserService } from './config-parser.service';

// Limit the available chart types while we are developing
const AVAILABLE_CHART_TYPES = ['line', 'bar'];

@Component({
  selector: 'glxy-chart',
  templateUrl: './chart.component.html',
  styleUrls: ['./chart.component.scss'],
  standalone: false,
})
export class ChartComponent implements OnInit, OnChanges {
  @Input() config: ChartConfiguration;
  @Input() data: ChartData;
  @Input() htmlLegend = false;
  @Output() htmlLegendContent: EventEmitter<string> = new EventEmitter<string>(true);

  @ViewChild('chartJsChartContainer', { static: true })
  chartContainer: ElementRef;

  private canvasContext: CanvasRenderingContext2D;
  private chartObj;

  constructor(private readonly configParserService: ConfigParserService) {}

  ngOnInit() {
    if (this.config) {
      if (AVAILABLE_CHART_TYPES.indexOf(this.config.type) === -1) {
        throw new Error(
          `The chart type "${this.config.type}" is not a supported chart type. Please reach out to #wisakejak to request this chart type`,
        );
      }
      this.setupChartJsContainer();
      if (this.htmlLegend) {
        this.emitHtmlLegend();
      }
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (!!changes.config && !changes.config.firstChange) {
      const options = this.configParserService.parseConfig(this.canvasContext, this.config);
      this.chartObj.options = options;
      this.chartObj.update();
    }
    if (!!changes.data && !changes.data.firstChange) {
      this.chartObj.data = this.data;
      this.chartObj.update();
    }
    if (this.htmlLegend && this.config) {
      this.emitHtmlLegend();
    }
  }

  /**
   * Constructs the canvas object and sets up the chart container
   */
  private setupChartJsContainer() {
    this.canvasContext = (this.chartContainer.nativeElement as HTMLCanvasElement).getContext('2d');

    const options = this.configParserService.parseConfig(this.canvasContext, this.config);
    this.chartObj = new Chart(this.canvasContext, {
      type: this.config.type,
      data: this.data,
      options,
    });
  }

  emitHtmlLegend() {
    if (this.chartObj) {
      this.htmlLegendContent.emit(this.chartObj.generateLegend());
    }
  }
}
